export function parseSessionsText(sessions = [], t) {
  const uniqueModuleResources = new Set();

  return sessions
    .filter((s) => {
      if (s?.session_resource_type === 'session') return true;
      const resourceKey = `${s?.resource_id}-${s?.resource_type}`;
      if (uniqueModuleResources.has(resourceKey)) return false;
      uniqueModuleResources.add(resourceKey);
      return true;
    })
    .sort((a, b) => a.session_order - b.session_order)
    .map((s) => {
      return {
        ...s,
        text: s?.session_resource_type === 'session' ? t('lesson:Session') + ' ' + s?.session_order : t('lesson:Module resource'),
      };
    });
}
